import { Car, Bike, ShieldAlert } from "lucide-react";

export const Services = () => (
    <section
        id="servicos"
        data-testid="services-section"
        className="py-24 bg-white border-b border-neutral-200"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="text-center max-w-2xl mx-auto mb-16">
                <span className="text-xs font-bold uppercase tracking-widest text-[#ff6200]">
                    Especialidades
                </span>
                <h2 className="display-type text-3xl sm:text-5xl text-neutral-900 mt-2">
                    SERVIÇOS DE GUINCHO PLATAFORMA
                </h2>
                <p className="text-neutral-600 text-sm mt-3">
                    Tecnologia hidráulica e asa-delta para embarque nivelado sem riscos à suspensão.
                </p>
            </div>

            <div className="rounded-2xl overflow-hidden border border-neutral-300 shadow-lg mb-12 aspect-[3/2] relative bg-neutral-900">
                <img
                    src="/assets/servicos-guincho-tomizo.jpg"
                    alt="Caminhão guincho de plataforma GUINCHO TMZ transportando SUV ao pôr do sol em Miracatu SP"
                    data-testid="services-banner-image"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                />
            </div>

            <div className="grid md:grid-cols-3 gap-8">
                <div
                    data-testid="service-card-flatbed"
                    className="bg-[#f8f9fa] rounded-xl p-6 border border-neutral-200 flex flex-col justify-between space-y-6"
                >
                    <div>
                        <div className="w-12 h-12 rounded-lg bg-[#ff6200]/10 text-[#ff6200] flex items-center justify-center mb-4">
                            <Car className="w-7 h-7" />
                        </div>
                        <h3 className="display-type text-2xl text-neutral-900">PLATAFORMA INCLINÁVEL</h3>
                        <p className="text-xs text-neutral-600 mt-2 leading-relaxed">
                            A carroceria inclinável permite que o veículo suba rodando ou seja puxado
                            por cabo de aço, oferecendo praticidade e segurança durante o embarque.
                        </p>
                    </div>
                    <div className="mono-type text-[11px] font-bold text-[#ff6200] uppercase tracking-wider flex items-center gap-2">
                        <Car className="w-4 h-4" /> Carros, SUVs e Utilitários
                    </div>
                </div>

                <div
                    data-testid="service-card-asdelta"
                    className="bg-[#f8f9fa] rounded-xl p-6 border border-neutral-200 flex flex-col justify-between space-y-6"
                >
                    <div>
                        <div className="w-12 h-12 rounded-lg bg-[#ff6200]/10 text-[#ff6200] flex items-center justify-center mb-4">
                            <Bike className="w-7 h-7" />
                        </div>
                        <h3 className="display-type text-2xl text-neutral-900">SISTEMA ASA-DELTA</h3>
                        <p className="text-xs text-neutral-600 mt-2 leading-relaxed">
                            Guincho de plataforma tipo asa-delta com capacidade para transportar até
                            dois veículos, conforme as condições de carga e operação.
                        </p>
                    </div>
                    <div className="mono-type text-[11px] font-bold text-[#ff6200] uppercase tracking-wider flex items-center gap-2">
                        <Bike className="w-4 h-4" /> Capacidade 2 Veículos &bull; Motos
                    </div>
                </div>

                <div
                    data-testid="service-card-warning"
                    className="bg-neutral-900 text-white rounded-xl p-6 border border-neutral-800 flex flex-col justify-between space-y-6"
                >
                    <div>
                        <div className="inline-block px-2.5 py-1 bg-red-600/30 border border-red-500 text-red-300 rounded text-[10px] font-bold uppercase tracking-wider mb-4">
                            Aviso Importante
                        </div>
                        <h3 className="display-type text-2xl text-white">PROTEÇÃO DO SEU VEÍCULO</h3>
                        <p className="text-xs text-neutral-300 mt-2 leading-relaxed">
                            Importante: não trabalhamos com guincho de corrente e gancho nem com
                            sistema de reboque integrado tipo lança. Somente guincho de plataforma,
                            para total proteção do seu veículo.
                        </p>
                    </div>
                    <div className="mono-type text-[11px] font-bold text-neutral-400 uppercase tracking-wider flex items-center gap-2">
                        <ShieldAlert className="w-4 h-4" /> 100% Livre de Correntes
                    </div>
                </div>
            </div>
        </div>
    </section>
);
